import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';

import { ArrowForward } from '@mui/icons-material';
import { OnboardingStepProps } from 'src/pages/onboarding/OnboardingPage';

interface CheckoutDetailsDescriptionProps extends OnboardingStepProps {
  isLoading: boolean;
}

const CheckoutDetailsDescription = ({ onNextStep, isLoading }: CheckoutDetailsDescriptionProps) => (
  <Grid
    container
    direction="column"
    justifyContent="center"
    alignItems="center"
    sx={{ height: '100%' }}
  >
    <div>
      <Typography variant="h4" align="center" sx={{ mb: 2 }}>
        Payment Details
      </Typography>
      <Box sx={{ mb: 3 }}>
        <Typography sx={{ p: 2 }}>We’re almost done!</Typography>
        <Typography sx={{ p: 2 }}>
          We need to securely collect your payment information to bill you for your subscription
        </Typography>
      </Box>
      <Box sx={{ mt: 8, display: 'flex', justifyContent: 'center' }}>
        <LoadingButton
          variant="contained"
          size="large"
          onClick={onNextStep}
          loading={isLoading}
          endIcon={<ArrowForward />}
        >
          Add Payment Details
        </LoadingButton>
      </Box>
    </div>
  </Grid>
);

export default CheckoutDetailsDescription;
